// Order.js
// Redux Container for Order View

// Imports
import { connect } from 'react-redux';
import ReportView from '../components/ReportView/';

// State Mapper
const mapStateToProps = state => ({
  products: state.product,
  clients: state.client,
  orders: state.order,
});

// Action Mapper
const mapDispatchToProps = dispatch => ({
})

// Exports
export default connect(mapStateToProps, mapDispatchToProps)(ReportView);


// WEBPACK FOOTER //
// ./src/containers/Report.js